/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Http_ErrorInputs */



/**
* | output |
* | --- |
* | "The endpoint answered with an error." |
*
* @param {Private_Models_Hint_Http_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_http_error = /** @type {((inputs?: Private_Models_Hint_Http_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Http_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Endpunkt hat mit einem Fehler geantwortet.")
	return /** @type {LocalizedString} */ ("The endpoint answered with an error.")
});